<div id="sub-top">
    <div class="img-wrap">
        <img src="/assets/images/product.png">
        <h2 data-aos="fade-right" data-aos-duration="2000">
            <strong>영상인식과 사물인식 </strong> 그리고<strong> 인공지능 알고리즘</strong>의 기술력을 기반으로 <br>
        우리의 삶의 가치를 더하는 소프트웨어를 개발합니다. 
        </h2>
    </div>
</div>
<section [ngSwitch]='subPage'> 
    <!-- <a href="#sub-top" id="tothetop"><i class="xi-angle-up-thin"></i></a> -->
    <div class="sub-path">
        <ul >
            <li>제품소개 ></li>
            <li *ngSwitchCase="'billiai'">BilliAi</li>
            <li *ngSwitchCase="'carrotly'">Carrotly</li>
            <li *ngSwitchDefault></li>
        </ul>
        <div class="tab">
            <ul>
                <li><a [ngClass]="{'on': subPage === 'billiai'}" (click)="subPage='billiai' " >Billi AI</a></li>
                <li><a [ngClass]="{'on': subPage === 'carrotly'}" (click)="subPage='carrotly'" >Carrotly</a></li>
            </ul>

            <!-- select bar -->
            <div *ngSwitchCase="'billiai'" class="tab-indicator product-bliilai"></div>
            <div *ngSwitchCase="'carrotly'" class="tab-indicator product-carrotly"></div>
            <div *ngSwitchDefault></div>
        </div>
    </div>

    
    <!-- sub page -->
        <article *ngSwitchCase="'billiai'"> <app-billiai></app-billiai></article> 
        <article *ngSwitchCase="'carrotly'"><app-carrot></app-carrot></article>
        <article *ngSwitchDefault></article>

    
</section>